import { MarketAccessory, MarketActionCard, MarketRow } from '@market/react';
import { Icon, type IconName } from '@squareup/shared-ui-react';
import styles from './UpsellCard.module.css';

export interface UpsellCardProps {
  readonly label: string;
  readonly iconName: IconName;
  readonly sublabel: string;
  readonly onClick: () => void;
  readonly variant?: 'white' | 'gray';
}

export const UpsellCard = ({
  label, iconName, sublabel, onClick, variant = 'white',
}: UpsellCardProps) => {
  const cardClass = variant === 'gray' ? styles.upsellCardGrayVariant : variant === 'white' ? styles.upsellCardWhiteVariant : '';

  return (
    <MarketActionCard
      data-testid={`upsell-card-${label}`}
      className={cardClass}
      onClick={onClick}
    >
      <MarketRow variant="drill">
        <label slot="label">{label}</label>
        <p slot="subtext">{sublabel}</p>
        <MarketAccessory
          size="image"
          slot="leading-accessory"
        >
          <Icon iconName={iconName} />
        </MarketAccessory>
      </MarketRow>
    </MarketActionCard>
  );
};
